import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import SettingsTab from './components/SettingsTab';
import ConfigurationPanel from './components/ConfigurationPanel';
import SystemSidebar from './components/SystemSidebar';

const SystemSettingsAndConfiguration = () => {
  const [activeTab, setActiveTab] = useState('authentication');

  const tabs = [
    {
      id: 'authentication',
      label: 'Authentication',
      icon: 'Shield'
    },
    {
      id: 'scheduling',
      label: 'Scheduling Rules',
      icon: 'Calendar'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: 'Bell'
    },
    {
      id: 'integrations',
      label: 'Integrations',
      icon: 'Zap'
    },
    {
      id: 'security',
      label: 'Security',
      icon: 'Lock'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="pt-16">
        <div className="p-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb />
            
            <div className="mb-6">
              <h1 className="text-3xl font-semibold text-foreground mb-2">
                System Settings & Configuration
              </h1>
              <p className="text-muted-foreground">
                Manage system-wide settings, security policies, and integration configurations for the employee portal.
              </p>
            </div>
          </div>
        </div>

        <div className="flex h-[calc(100vh-200px)]">
          <div className="flex-1 flex flex-col bg-card border-t border-border">
            <SettingsTab 
              tabs={tabs} 
              activeTab={activeTab} 
              onTabChange={setActiveTab} 
            />
            <ConfigurationPanel activeTab={activeTab} />
          </div>
          <SystemSidebar />
        </div>
      </div>
    </div>
  );
};

export default SystemSettingsAndConfiguration;